
const variables = {}

if (process.env.NODE_ENV == 'development') {
  variables.apiSvrUrl = 'http://localhost:4000/'
  variables.cliSvrUrl = 'http://' + location.host + '/'
}
else {
  variables.apiSvrUrl = 'http://marubooks.com:9110/'
  variables.cliSvrUrl = 'http://marubooks.com/'
}

variables.googlePlay = 'https://play.google.com/store/apps/details?id='
variables.ibooks = ''
variables.prvUrl = 

function _set(k, v)
{
  variables[k] = v
}

function _get(k)
{
  return variables[k]
}

export default {
  set (k, v) {
    _set(k, v)
  },
  get (k) {
    return _get(k)
  },
  prvUrl (v) {
    return v ? `http://aspenux.com/excp/edp/book/${v}/EPUB3.html` : ''
  }
}